import {Component} from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss', './app.component.mac.scss']
})
export class AppComponent {

  constructor() {

  }

  get isHeadless() {
    return window.location.href.includes('/add');
  }

}
